<template>
  <div class="container">
    <div class="code-icon-cell">
      <div class="icon-box">
        <span class="out-circle" />
        <span class="inner-circle" />
        <i :class="item.icon" />
      </div>
      <div class="title">{{ item.title }}</div>
      <div class="num">
        已有<span class="blue">{{ item.num }}</span
        >人练习
      </div>
    </div>
    <div class="hover-icon-cell" @click="onClick">
      <div class="icon-box">
        <span class="out-circle" />
        <span class="inner-circle" />
        <a class="btn">我要练习</a>
      </div>
      <div class="title blue">{{ item.title }}</div>
      <div class="num ques">
        共有<span class="blue">{{ item.ques }}</span
        >道题
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'code-icon-cell',
  props: ['item'],
  data() {
    return {}
  },
  methods: {
    onClick() {
      this.$router.push({
        path: '/practice/code',
        query: { title: this.item.title },
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.container {
  position: relative;
  display: inline-block;
  cursor: pointer;
  width: 250px;
  height: 220px;
  margin: 10px;
  text-align: center;
  padding: 10px;

  border: 1px solid #eff0f2;
  .code-icon-cell {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 150;
    font-weight: 340;
    background-color: #f8f9fb;
    .title {
      padding: 10px 0;
    }
    .blue {
      color: #29bdb9;
    }
    .num {
      font-size: 14px;
      padding: 10px 0 20px 0;
    }
    .ques {
      font-size: 14px;
      padding: 10px 0 20px 0;
      display: none;
    }
    &:hover {
      .num {
        display: none;
      }
      .ques {
        display: block;
      }
    }
    .icon-box {
      width: 100%;
      height: 60px;
      margin: 20px 0;
      position: relative;
      .out-circle,
      .inner-circle,
      .iconfont {
        position: absolute;
        top: 50%;
        height: 50%;
        transform: translate(-50%, -50%);
        &.out-circle {
          width: 80px;
          height: 80px;
          border-radius: 50%;
          border: 1px solid #e8f3f6;
          background-color: #f8f9fb;
          z-index: 101;
        }
        &.inner-circle {
          width: 60px;
          height: 60px;
          border-radius: 50%;
          border: 1px dashed #b8e2e7;
          background-color: #fff;
          z-index: 102;
        }
        &.iconfont {
          z-index: 103;
          margin: auto;
          color: #29bdb9;
          font-size: 30px;
        }
      }
    }
  }
  &:hover .hover-icon-cell {
    display: block;
  }
  .hover-icon-cell {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 151;
    display: none;
    background-color: #fff;
    box-shadow: #eff0f2 0px 2px 12px 6px;
    .title {
      padding: 10px 0;
    }
    .blue {
      color: #29bdb9;
    }
    .num {
      font-size: 14px;
      padding: 10px 0 20px 0;
    }
    .icon-box {
      width: 100%;
      height: 60px;
      margin: 20px 0;
      position: relative;
      .out-circle,
      .inner-circle,
      .btn {
        position: absolute;
        top: 50%;
        height: 50%;
        transform: translate(-50%, -50%);
        &.out-circle {
          width: 68px;
          height: 68px;
          border-radius: 50%;
          border: 1px solid #e8f3f6;
          background-color: #f8f9fb;
          z-index: 101;
        }
        &.inner-circle {
          width: 60px;
          height: 60px;
          border-radius: 50%;
          border: 1px dashed #b8e2e7;
          background-color: #fff;
          z-index: 102;
        }
        &.btn {
          z-index: 103;
          padding: 2px 15px;
          span {
            font-size: 12px;
            font-weight: 400;
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/practice/company/code-icon-cell.vue